import { getAppDir } from './Url';

export function route(icone, nome, link) {
    let route = {};
    
    route.icone = icone;
    route.nome = nome;
    route.link = getAppDir() + link;

    return route;
}

export function register(icone, nome, link) {
    let route = {};
    
    route.icone = icone;
    route.nome = nome;
    route.link = getAppDir() + link;    

    return route;
}